import Vue from 'vue'
import Vuex from 'vuex'

import HomeModule from './module/home-module'
import GalleryModule from './module/gallery-module'
import PropertyModule from './module/property-module'
import AppSettingsModule from './module/app-settings-module'
import ExcursionsModule from './module/excursions-module'
import AboutModule from './module/about-module'
import InquiryModule from './module/inquiry-module'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    appSettings: AppSettingsModule,
    home: HomeModule,
    gallery: GalleryModule,
    excursions: ExcursionsModule,
    property: PropertyModule,
    about: AboutModule,
    inquiry: InquiryModule
  }
})

export default store
